interface PunishmentTypeSelectorProps {
  selectedType: 'warn' | 'timeout' | 'kick' | 'ban';
  onSelectType: (type: 'warn' | 'timeout' | 'kick' | 'ban') => void;
}

const PUNISHMENT_TYPES = [
  { value: 'warn', label: '경고', description: '멤버에게 경고를 부여합니다', icon: '⚠️' },
  { value: 'timeout', label: '타임아웃', description: '일정 시간 동안 메시지 전송을 차단합니다', icon: '⏰' },
  { value: 'kick', label: '추방', description: '서버에서 멤버를 추방합니다', icon: '👢' },
  { value: 'ban', label: '차단', description: '서버에서 멤버를 영구적으로 차단합니다', icon: '🔨' },
] as const;

export default function PunishmentTypeSelector({ selectedType, onSelectType }: PunishmentTypeSelectorProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {PUNISHMENT_TYPES.map((type) => (
        <button
          key={type.value}
          type="button"
          onClick={() => onSelectType(type.value)}
          className={`p-4 rounded-lg border-2 transition-all text-left ${
            selectedType === type.value
              ? 'border-[#FF7A7A] bg-gradient-to-r from-[#FF7A7A]/10 to-[#DD8DFF]/10'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <div className="flex items-start space-x-3">
            <span className="text-2xl">{type.icon}</span>
            <div className="flex-1">
              <div className="font-semibold text-gray-900">{type.label}</div>
              <div className="text-sm text-gray-600 mt-1">{type.description}</div>
            </div>
            {selectedType === type.value && (
              <svg className="w-5 h-5 text-[#FF7A7A]" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
        </button>
      ))}
    </div>
  );
}
